import { Card, Col, Layout, Row, Spin, Typography } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "./style.css";

import dayjs from "dayjs";

import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { Env } from "./../../../styles";

import ReactApexChart from "react-apexcharts";
const { Text } = Typography;

/* eslint-disable react-hooks/rules-of-hooks */
export default function summaryData(props) {
  const [cookies, setCookie, removeCookie] = useCookies(["userId"]);
  const location = useLocation();

  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [data, setData] = useState([]);
  const [serData, setSerData] = useState([]);
  const [salSpin, setSalSpin] = useState(true);
  const [attDates, setAttDates] = useState([]);
  const [attAtt, setAttAtt] = useState([]);
  const [attLeave, setAttLeave] = useState([]);
  const [attSpin, setAttSpin] = useState(true);
  const [thresholds, setThresholds] = useState([]);
  const [attCount, setAttCount] = useState(0);
  const [leaveCount, setLeaveCount] = useState(0);
  const [spiderData, setSpiderData] = useState([]);

  const [star, setStar] = useState(0);

  const dround = Number(
    props.setting?.find((item) => item.key == "admin.discounts_round")?.value ||
      0,
  );
  const roundDiscount = (value) => {
    const n = Number(value) || 0;
    if (dround > 0) return Math.round(n / dround) * dround;
    return Math.round(n);
  };

  const config = {
    options: {
      chart: {
        width: 380,
        type: "pie",
      },

      colors: [
        "#008FFB", // سُلف
        "#775DD0", // أقساط
        "#FEB019", // تأخرات
        "#A3192E", // غياب
        "#FF0505", // جزاءات
        "#8c8c8c", // التكافل
        "#00E396", // صافي الاستحقاق
      ],

      labels: [
        "سُلف",
        "أقساط",
        "تأخرات",
        "غياب",
        "جزاءات",
        "التكافل",
        "صافي الاستحقاق",
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      series: serData,
    },
  };
  const config2 = {
    series: [
      {
        name: "صافي الدوام",
        data: attAtt,
      },
      {
        name: "الدوام المثالي",
        data: thresholds,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        curve: ["smooth", "stepline"],
        width: 2,
      },
      xaxis: {
        type: "datetime",
        categories: attDates,
      },
      yaxis: {
        type: "datetime",
        min: 0,
        max: 660,
        tickAmount: 7,
      },
      tooltip: {
        style: {
          fontFamily:
            "Tajawal, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
          marginLeft: "5px",
        },
        x: {
          show: true,
          format: "dd-MM-yyyy",
        },
        y: {
          format: "HH:mm",
          formatter: function (val, opts) {
            return parseInt(val / 60) + ":" + (val % 60);
          },
        },
      },
    },
  };
  const configSpider = {
    options: {
      chart: {
        dropShadow: {
          enabled: true,
          blur: 1,
          left: 1,
          top: 1,
        },
      },
      dataLabels: {
        enabled: true,
        background: {
          enabled: true,
          borderRadius: 2,
        },
      },
      xaxis: {
        categories: [
          "الحضور المبكر",
          "الانضباط",
          "الانصراف",
          "نسبة أيام الحضور",
          "احترام النظام",
        ],
        labels: {
          show: true,
          style: {
            colors: ["#808080"],
            fontSize: "11px",
            fontFamily:
              "Tajawal, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
          },
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 5,
      },
      colors: ["#0972B6", "#002612"],
      stroke: {
        width: 1,
      },
      fill: {
        opacity: 0.5,
      },
      markers: {
        size: 5,
      },
    },
    series: [
      {
        name: "النسبة",
        data: props.spiderData,
      },
    ],
  };
  const id = cookies.user;
  let user = props.userData;
  // let  user=location.userData;
  if (location.userData != null) user = location.userData;

  const [filter, setFilter] = useState(configSpider.series);

  const handleSizeChange = (e) => {
    setFilter([{ name: "أسامة جليل", data: [90, 60, 70, 80] }]);
  };
  function getTwentyFourHourTime(amPmString) {
    var d = new Date("1/7/2022 " + amPmString);
    return d.getHours() + ":" + d.getMinutes();
  }

  function getMinutesTime(amPmString) {
    if (amPmString == null) return 0;
    if (typeof amPmString === "number")
      return Math.max(0, Math.round(amPmString));
    const s = String(amPmString).trim();
    if (!s) return 0;

    // Supports: HH:mm, HH:mm:ss, and mixed strings containing time values.
    const match = s.match(/(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?/);
    if (match) {
      const h = Number(match[1]) || 0;
      const m = Number(match[2]) || 0;
      return h * 60 + m;
    }

    const asNumber = Number(s);
    if (Number.isFinite(asNumber)) return Math.max(0, Math.round(asNumber));
    return 0;
  }

  function getRequiredDailyMinutesFromLogs(logs) {
    const arr = Array.isArray(logs) ? logs : [];
    const mins = arr
      .map((l) => getMinutesTime(l?.duartion))
      .filter((m) => Number(m) > 0);
    if (!mins.length) return 7 * 60;
    return mins.reduce((a, b) => a + b, 0) / mins.length;
  }

  function getLateMinutesValue(v) {
    if (v == null) return 0;
    if (typeof v === "number") return Math.max(0, v);
    return Math.max(0, getMinutesTime(String(v)));
  }

  useEffect(() => {
    if (props.setting.length) {
      setStart(
        props.setting
          ? dayjs(
              dayjs().format("YYYY-MM") +
                "-" +
                props.setting.filter(
                  (item) => item.key == "admin.month_start",
                )[0]?.value,
              "YYYY-MM-DD",
            )
              .subtract(1, "months")
              .format("YYYY-MM-DD")
          : null,
      );
      setEnd(
        props.setting
          ? dayjs(
              dayjs().format("YYYY-MM") +
                "-" +
                props.setting.filter((item) => item.key == "admin.month_end")[0]
                  ?.value,
              "YYYY-MM-DD",
            ).format("YYYY-MM-DD")
          : null,
      );
    } else {
      var setting;
      axios
        .get(Env.HOST_SERVER_NAME + "setting/" + props.userData.user_id)
        .then((response) => {
          setting = response.data;
          setStart(
            dayjs(
              dayjs().format("YYYY-MM") +
                "-" +
                setting.filter((item) => item.key == "admin.month_start")[0]
                  ?.value,
              "YYYY-MM-DD",
            )
              .subtract(1, "months")
              .format("YYYY-MM-DD"),
          );
          setEnd(
            dayjs(
              dayjs().format("YYYY-MM") +
                "-" +
                setting.filter((item) => item.key == "admin.month_end")[0]
                  ?.value,
              "YYYY-MM-DD",
            ).format("YYYY-MM-DD"),
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    axios
      .get(
        Env.HOST_SERVER_NAME +
          "salary-info/" +
          id.user_id +
          "/" +
          start +
          "/" +
          end,
      )
      .then((response) => {
        setData(response.data);

        const salary = response.data.lists?.[0]?.salary || 0;
        const absenceCostRaw = Number(
          response.data.lists?.[0]?.["absenceCost"] || 0,
        );
        const requiredDailyMinutes =
          Number(response.data.lists?.[0]?.requiredDailyMinutes) > 0
            ? Number(response.data.lists?.[0]?.requiredDailyMinutes)
            : getRequiredDailyMinutesFromLogs(response.data.logs);
        const lateMinutes = getLateMinutesValue(
          response.data.lists?.[0]?.["lateTime"] || 0,
        );

        const debt = parseInt(response.data.lists?.[0]?.["debt"] || 0);
        const longDebt = parseInt(response.data.lists?.[0]?.["long_debt"] || 0);
        const latePriceRaw =
          requiredDailyMinutes > 0
            ? (Number(salary) / (requiredDailyMinutes * 30)) * lateMinutes
            : Number(response.data.lists?.[0]?.["lateTimePrice"] || 0);
        const latePrice = roundDiscount(latePriceRaw);
        const absenceCost = roundDiscount(absenceCostRaw);
        const punishments = parseInt(
          response.data.lists?.[0]?.["vdiscount"] || 0,
        );
        const symbiosis = parseInt(
          response.data.lists?.[0]?.["symbiosis"] || 0,
        );

        setSerData([
          debt, // سُلف
          longDebt, // أقساط
          latePrice, // تأخرات
          absenceCost, // غياب
          punishments, // جزاءات
          symbiosis, // التكافل
          salary -
            (debt +
              longDebt +
              latePrice +
              absenceCost +
              punishments +
              symbiosis), // صافي الاستحقاق
        ]);
        setSalSpin(false);

        var dates = [];
        var atts = [];
        // var leaves=[];
        var thr = [];
        response.data.logs.map(function (item) {
          //if(item.dayName!='الجمعة'){
          dates.push(item.date);
          const requiredMinutesForDay = getMinutesTime(item.duartion);
          const workedMinutesForDay = getMinutesTime(item.workHours);
          const defaultRequiredMinutes = Math.round(
            requiredDailyMinutes || 7 * 60,
          );
          // The ideal line should follow required shift minutes per day,
          // and only drop to zero for days with no required shift.
          thr.push(
            requiredMinutesForDay > 0
              ? requiredMinutesForDay
              : defaultRequiredMinutes,
          );
          atts.push(workedMinutesForDay);
          //}
          //  leaves.push(getTwentyFourHourTime(item.leave_time));
        });
        setAttDates(dates);
        setAttAtt(atts);
        setThresholds(thr);
        // setAttLeave(leaves);
        setAttSpin(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [start, end]);

  return (
    <Layout>
      <Row className="summary" style={{ paddingBottom: "10px" }}>
        <Col style={{ padding: "10px" }} className="pieColumn" lg={10} sm={24}>
          <Card style={{ height: "100%" }}>
            <Spin spinning={salSpin}>
              <ReactApexChart
                className="pie-chart"
                options={config.options}
                series={config.options.series}
                type="pie"
                height="400"
                width="400"
                style={{
                  padding: 0,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              />
              <div style={{ textAlign: "center", paddingBottom: "20px" }}>
                <Text>ملخص المستحقات للفترة {start + " - " + end} </Text>
              </div>
            </Spin>
          </Card>
        </Col>
        <Col style={{ padding: "10px" }} className="pieColumn" lg={14} sm={24}>
          <Card>
            <Spin spinning={attSpin}>
              <ReactApexChart
                options={config2.options}
                series={config2.series}
                type="area"
                height="250"
                style={{ padding: 0 }}
              />
              <div style={{ textAlign: "center" }}>
                <Text>حركة الحضور والانصراف لآخر 30 يوماً</Text>
              </div>
            </Spin>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
}
